import classNames from 'classnames';
import React from 'react';

import { useElementSizeVariable } from 'common/hooks';

import { getClassNameFromRoute } from '../../../services/className.service';

type HeaderProps = {
  className?: string;
  renderOnHide?: () => React.ReactNode;
};

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({ children, className = '', renderOnHide }) => {
  const { ref: headerRef } = useElementSizeVariable('header-height', true);

  const collapsibleHeaderClassName = classNames({
    header: true,
    'header-collapsible': renderOnHide,
    [className]: className,
  });

  const headerClassName = classNames({
    header: true,
    [`header__${getClassNameFromRoute()}`]: true,
    [className]: className,
  });

  return (
    <>
      <header ref={headerRef} data-test='header' className={headerClassName} id='header'>
        {children}
      </header>
      {renderOnHide && <header className={collapsibleHeaderClassName}>{renderOnHide()}</header>}
    </>
  );
};

export default Header;
